import { useGetCurrentUser, useGetPortalSummary, useListAPIProducts } from 'api/hooks';
import { webAppAPI } from 'api/web-app';
import { DynamicPage as DynamicPagePB } from 'proto/web_app_grpc_pb';
import React from 'react';
import useSWR from 'swr';
import { Loading } from './Loading';

export type DynamicPageProps = { page?: DynamicPagePB.AsObject };

export const DynamicPageComponent: React.FC<DynamicPageProps> = props => {
  const { currentUser, currentUserError } = useGetCurrentUser();
  const { apiCatalogInfo, apiCatalogInfoError } = useListAPIProducts();
  const { portalSummary, portalSummaryError } = useGetPortalSummary();

  React.useEffect(() => {
    document.title = `${portalSummary?.displayName ?? 'Portal'} - ${props.page?.name}`;
  }, [portalSummary?.displayName, props.page?.name]);

  React.useEffect(() => {
    let iframeEl = document.getElementById('dynamic-page');
    let iframeWindow = (iframeEl as HTMLIFrameElement)?.contentWindow;

    iframeEl?.addEventListener('load', () => {
      iframeWindow?.postMessage(
        {
          currentUser,
          portalSummary,
          apiProductsList: apiCatalogInfo?.apiProductsList
        },
        '*'
      );
    });
    iframeEl?.setAttribute('src', props.page?.url!);
    iframeEl?.setAttribute('height', '100%');
    iframeEl?.setAttribute('width', '100%');
  }, [props.page?.url!, !!apiCatalogInfo, !!currentUser, !!portalSummary]);

  if (
    (!currentUser && !currentUserError) ||
    (!apiCatalogInfo && !apiCatalogInfoError) ||
    (!portalSummary && !portalSummaryError)
  ) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      <iframe id={`dynamic-page`} role='main'></iframe>
    </React.Fragment>
  );
};
